/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import ContentCard from 'components/ContentCard/index';
import Layout from 'components/Layout/index';
import StepNavigation from "components/StepNavigation";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Button, { ButtonContainer } from 'components/Button';
import React, { useContext, useEffect, useRef, useState } from 'react';
import {
    usePaymentConfigurationForm,
    usePaymentPackHtmlModal,
    usePaymentPackSendApproval,
    useSavePaymentPackContactParties
} from 'services/PaymentPackService'
import { useHeaderNbi, useWordingHtmlModal } from 'services/QuoteService';

import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { useHistory } from '../../../../../node_modules/react-router-dom/cjs/react-router-dom.min';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Field, Form, Formik } from 'formik';
import Loader from 'components/Loader/index';
import Colors from 'constants/Colors';
import EmailModal from 'components/EmailModal/index';
import { RenderButtons } from 'components/index';
import { ButtonContent } from '../contractBuilder/styles';
import { AttachmentContainer } from './styles';
import TagList3 from 'components/TagList3/index';
import { useGetQuestionnaireAnswer, useSaveQuestionnaireAnswerSync } from 'services/QuestionnaireAnswerService';
import { GeneralSection, PartiesEmailInfo } from './sections/index';
import { getDocumentType, getRecipients, renderEmails } from './utils';
import { cloneDeep } from 'lodash';

const PARTY_ID_QUESTION_ID = 2199;

function PaymentPackSummaryDistribution(props) {
    const [summary, setSummary] = useState({});
    const [historymsg, setHistorymsg] = useState([]);
    const [endorsmentType, setEndorsmentType] = useState("");
    const [files, setFiles] = useState([]);
    const [contactsParties, setContactsParties] = useState({
        client: null,
        insurers: [],
        externalBrokers: [],
        thirdParties: [],
    });
    const [isClaims, setIsClaims] = useState(false);
    const [currentParty, setCurrentParty] = useState({
        idPersonInsurer: null,
        insurerFirstName: null,
        contactsCC: null,
        contactsTo: null,
        subject: null,
        emailBody: null
    });
    const [allParties, setAllParties] = useState([]);
    const [paymentDocs, setPaymentDocs] = useState([]);
    const [generatePaymentPack, setGeneratePaymentPack] = useState(null);
    const [isEndorsementWithoutPaymentPack, setIsEndorsementWithoutPaymentPack] = useState(false);
    const [statusEndorsement, setStatusEndorsement] = useState({
        title: "Payment Pack",
        route: "",
    });

    const formik = useRef(null);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const loading = useContext(GlobalLoaderContext);
    const authContext = useContext(GlobalAuthContext);
    const mc = new MessageCenter();

    const isDirectPaymentAnswer = props.location?.state?.isDirectPaymentAnswer;

    const refQuestionnaireSent = useRef(false);

    const [questionnaire, setQuestionnaire] = useState([]);
    const [emailContentGroup, setEmailContentGroup] = useState([]);

    const SECTIONS = {
        PARTIES_EMAIL_INFO: { name: 'PARTIES_EMAIL_INFO', isMultiple: true },
    }

    const {
        data: useHeaderNbiData,
        loading: useHeaderNbiLoading,
        error: useHeaderNbiError,
        status: useHeaderNbiStatus,
        request: useHeaderNbiRequest
    } = useHeaderNbi();

    const {
        data: usePaymentPackHtmlModalData,
        loading: usePaymentPackHtmlModalLoading,
        error: usePaymentPackHtmlModalError,
        status: usePaymentPackHtmlModalStatus,
        request: usePaymentPackHtmlModalRequest,
    } = usePaymentPackHtmlModal(props.match.params.idOperation);

    const {
        data: useGetQuestionnaireAnswerData,
        loading: useGetQuestionnaireAnswerLoading,
        error: useGetQuestionnaireAnswerError,
        status: useGetQuestionnaireAnswerStatus,
        request: useGetQuestionnaireAnswerRequest
    } = useGetQuestionnaireAnswer(props.match.params.idOperation);

    const {
        loading: useSaveQuestionnaireAnswerLoading,
        request: useSaveQuestionnaireAnswerRequest,
    } = useSaveQuestionnaireAnswerSync(props.match.params.idOperation);


    const {
        data: usePaymentPackSendApprovalData,
        loading: usePaymentPackSendApprovalLoading,
        error: usePaymentPackSendApprovalError,
        status: usePaymentPackSendApprovalStatus,
        request: usePaymentPackSendApprovalRequest,
    } = usePaymentPackSendApproval();

    const {
        data: usePaymentConfigurationFormData,
        loading: usePaymentConfigurationFormLoading,
        error: usePaymentConfigurationFormError,
        status: usePaymentConfigurationFormStatus,
        request: usePaymentConfigurationFormRequest,
    } = usePaymentConfigurationForm(props.match.params.idOperation);

    const {
        data: useSavePaymentPackContactPartiesData,
        loading: useSavePaymentPackContactPartiesLoading,
        error: useSavePaymentPackContactPartiesError,
        status: useSavePaymentPackContactPartiesStatus,
        request: useSavePaymentPackContactPartiesRequest
    } = useSavePaymentPackContactParties();

    const {
        data: useWordingHtmlModalData,
        loading: useWordingHtmlModalLoading,
        error: useWordingHtmlModalError,
        status: useWordingHtmlModalStatus,
        request: useWordingHtmlModalRequest,
    } = useWordingHtmlModal(props.match.params.idOperation);

    useEffect(() => {
        if (
            useHeaderNbiLoading ||
            usePaymentPackHtmlModalLoading ||
            useGetQuestionnaireAnswerLoading ||
            usePaymentPackSendApprovalLoading ||
            usePaymentConfigurationFormLoading ||
            useSavePaymentPackContactPartiesLoading ||
            useWordingHtmlModalLoading ||
            useSaveQuestionnaireAnswerLoading
        ) {
            loading.start();
        } else {
            loading.stop();
        }
    }, [
        useHeaderNbiLoading,
        usePaymentPackHtmlModalLoading,
        useGetQuestionnaireAnswerLoading,
        usePaymentPackSendApprovalLoading,
        usePaymentConfigurationFormLoading,
        useSavePaymentPackContactPartiesLoading,
        useSaveQuestionnaireAnswerLoading,
        useWordingHtmlModalLoading
    ])

    useEffect(() => {
        if (useGetQuestionnaireAnswerStatus === 200) {
            handleQuestionnaire(useGetQuestionnaireAnswerData?.value);
        }
    }, [useGetQuestionnaireAnswerStatus])


    useEffect(() => {
        setIsEndorsementWithoutPaymentPack(!endorsmentType || ['off-risk', 'policy-extension', 'adjustments-and-corrections', 'client-change'].includes(endorsmentType));

        setStatusEndorsement({
            title: "ENDORSEMENT PACK",
            route: ''
        })
    }, [endorsmentType])


    const handleAttachmentsFile = (data) => {
        const questionnaire = [
            ...data.payments
        ]

        const attachmentsQst = questionnaire.find((qst) => qst.idQuestion === 2143);
        const attachments = JSON.parse(attachmentsQst?.answer);
        handleFiles(attachments);
    }

    function handleSummary() {
        useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
            setSummary({
                typeOfCover: data.ret_value.typeOfCover,
                client: data.ret_value.client,
                obligorCoding: data.ret_value.obligorCoding,
                responseBy: data.ret_value.responseBy,
                internalContact: data.ret_value.internalContact,
                broker: data.ret_value.broker,
                dealCode: data.ret_value.deal,
                nmFacility: data.ret_value.nmFacility,
                nmObligor: data.ret_value.nmObligor,
                projectName: data.ret_value.projectName,
                idOperation: props.match.params.idOperation,
            });

            if (data.ret_value.paymentPackMessage) {
                formik.current?.setFieldValue('internalMessage', data.ret_value.paymentPackMessage);
            }
            setHistorymsg(data.ret_value.historical);
            setEndorsmentType(data.ret_value.endorsmentType)
            setGeneratePaymentPack(!endorsmentType || ['not-pre-agreed', 'cancellation', 'pre-agreed', 'market-changes', 'declaration'].includes(endorsmentType))
            handlePaymentPackInfos(data.ret_value.endorsmentType);
        })
            .catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostSummary - Error:', error);
            })
    }

    function handlePaymentPackInfos(endorsmentType) {
        const isGeneratePaymentPack = !endorsmentType || ['not-pre-agreed', 'cancellation', 'pre-agreed', 'market-changes', 'declaration'].includes(endorsmentType)
        setGeneratePaymentPack(isGeneratePaymentPack)
        if (!isGeneratePaymentPack) {
            useWordingHtmlModalRequest(null, { renderWelcomekit: 1 }).then(({ data: resp }) => {
                if (resp.ret_code === 200) {
                    const { paymentPackDocs, contactsParties } = resp.ret_value;
                    console.log("resp.ret_value.policePackReturnDocs", resp.ret_value.policePackReturnDocs)
                    const packDocs = resp.ret_value.policePackReturnDocs
                        .map(document => ({
                            idDocument: document.idDocument,
                            idDomain: document.idDomain,
                            idDomainDescription: document.idDomainDescription,
                            idReport: document.idReport,
                            idOperation: document.idOperation,
                            reportToken: document.reportToken,
                            url: document.url,
                            urlLink: document.url,
                            fileName: document.documentMetadata.fileName,
                            title: document.documentMetadata.fileName,
                        }));

                    setFiles(packDocs);
                    setPaymentDocs(packDocs);

                    if (contactsParties) {
                        setContactsParties(contactsParties);
                        handleAllParties(contactsParties, isGeneratePaymentPack);
                    }
                } else {
                    mc.error(resp.ret_msg_details);
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handlePaymentPackInfos.name}\n` + error);
            });
        } else {
            usePaymentPackHtmlModalRequest().then(({ data: resp }) => {
                if (resp.ret_code === 200) {
                    const { paymentPackDocs, contactsParties } = resp.ret_value;
                    setFiles(paymentPackDocs);
                    setPaymentDocs(paymentPackDocs);

                    if (contactsParties) {
                        setContactsParties(contactsParties);
                        handleAllParties(contactsParties, isGeneratePaymentPack);
                    }
                } else {
                    mc.error(resp.ret_msg_details);
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handlePaymentPackInfos.name}\n` + error);
            });
        }
    };


    const handleAllParties = (dataContactParties, isGeneratePaymentPack) => {
        const { client, insurers, externalBrokers, thirdParties } = dataContactParties;
        let parties = [];

        if (!isDirectPaymentAnswer) {
            parties.push(client);
        }

        if (isGeneratePaymentPack) {
            parties = [...parties, ...insurers]
        }

        if (isGeneratePaymentPack && !isDirectPaymentAnswer) {
            if (externalBrokers) parties = [...parties, ...externalBrokers]

            if (thirdParties) parties = [...parties, ...thirdParties]
        }

        parties = parties.map((party) => ({
            ...party,
            emailBody: party.emailBody,
        }))

        setAllParties(parties);
    }

    const handleFiles = (attachments) => {
        const formattedAttachments = attachments.map((file) => {
            return {
                idDocument: file.idDocument,
                fileName: file.fileName,
                dsTypeDocument: file.documentType.dsAnswerOption,
                urlLink: file.fileUrl,
                recipients: getRecipients(file.idDocument, allParties),
            }
        })

        const formattedFiles = paymentDocs.map((file) => {
            return {
                idDocument: file.idDocument,
                fileName: file.title,
                dsTypeDocument: getDocumentType(file.idDomain),
                urlLink: file.urlLink,
                recipients: getRecipients(file.idDocument, allParties),
            }

        })

        setFiles([...formattedFiles, ...formattedAttachments]);

    }

    function getPaymentConfigurationForm() {
        usePaymentConfigurationFormRequest().then(({ data: response }) => {
            if (response.ret_code != 200) {
                mc.error(response.ret_msg_details);
                history.goBack();
                return;
            }

            setIsClaims(response.ret_value.isClaims);
        }).catch((error) => {
            mc.error(`There was an error while fetching your data: ${getPaymentConfigurationForm.name}\n` + error);
        });
    }

    function handlePaymentConfiguration() {
        history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
    };

    useEffect(() => {
        fitinsur.setAuthToken(authContext.token);

        getPaymentConfigurationForm();
        handleSummary();
    }, [])

    useEffect(() => {
        if (allParties.length > 0) {
            useGetQuestionnaireAnswerRequest();
        }
    }, [allParties])

    function handleSendApproval() {
        usePaymentPackSendApprovalRequest({
            idOperation: props.match.params.idOperation,
            policyPackMessage: formik.current.values.internalMessage
        }, null).then(({ data }) => {
            if (data.ret_code !== 200) {
                mc.error(data.ret_msg_details);
                return;
            }

            return isClaims ? history.push('/claims') : history.push('/policies');
        })
            .catch((error) => {
                mc.error("There was an error while fetching your data\n" + error);
            });
    }

    const updateContactParties = (currentParty) => {
        const { client, insurers, externalBrokers, thirdParties } = contactsParties;
        if (client.idPersonInsurer === currentParty.idPersonInsurer) {
            client.subject = currentParty.subject;
            client.emailBody = currentParty.emailBody;
        }

        for (const insurer of insurers) {
            if (insurer.idPersonInsurer === currentParty.idPersonInsurer) {
                insurer.subject = currentParty.subject;
                insurer.emailBody = currentParty.emailBody;
            }
        }

        if (externalBrokers) {
            for (const externalBroker of externalBrokers) {
                if (externalBroker.idPersonInsurer === currentParty.idPersonInsurer) {
                    externalBroker.subject = currentParty.subject;
                    externalBroker.emailBody = currentParty.emailBody;
                }
            }
        }

        if (thirdParties) {
            for (const thirdParty of thirdParties) {
                if (thirdParty.idPersonInsurer === currentParty.idPersonInsurer) {
                    thirdParty.subject = currentParty.subject;
                    thirdParty.emailBody = currentParty.emailBody;
                }
            }
        }

        const updatedContactParties = { client, insurers, externalBrokers, thirdParties }

        handleAllParties(updatedContactParties);

        return updatedContactParties;
    }

    function handleQuestionnaire(data) {
        handleAttachmentsFile(useGetQuestionnaireAnswerData?.value);

        let questionnaire = [
            ...data.payments,
        ];

        if (questionnaire && questionnaire.length > 0) {
            questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

            questionnaire = PartiesEmailInfo.events.handleInitialAdjustments({ questionnaire })
            let emailContentGroupQuestions = GeneralSection.events.groupMultipleFieldQuestions({
                mainIdQuestion: PARTY_ID_QUESTION_ID,
                questionnaire,
                handleQuestionsInitialAdjustments: null,
            });

            let duplicatedEmailContent = [];

            if (Array.isArray(allParties) &&
                allParties.length > 0 &&
                Array.isArray(emailContentGroupQuestions) &&
                emailContentGroupQuestions.length > 0
            ) {
                allParties.forEach((party, index) => {
                    const { idPersonInsurer } = party;
                    const { contactsTo } = party;
                    const { contactsCC } = party;
                    const { emailBody } = party;
                    const { subject } = party;

                    let matchingGroupQuestions = emailContentGroupQuestions.find((group) => {
                        return group.find((question) => question.idQuestion === PARTY_ID_QUESTION_ID && `${question.answer}` === `${idPersonInsurer}`);
                    });

                    if (!matchingGroupQuestions) {
                        matchingGroupQuestions = JSON.parse(JSON.stringify(emailContentGroupQuestions[0]));
                        if (index > 0) {
                            matchingGroupQuestions = matchingGroupQuestions.map((question) => ({
                                ...question,
                                answer: "",
                                answerJson: "",
                                idAnswerOption: null,
                                idPerson: null,
                                idQuestionnaireAnswers: null,
                                idQuestionnaireAnswersParent: null,
                                idQuestionnaireAnswersRoot: null,
                                key: null,
                            }));
                        }
                    }

                    matchingGroupQuestions = JSON.parse(JSON.stringify(matchingGroupQuestions));

                    const updatedQuestion = cloneDeep(matchingGroupQuestions)?.map((question) => {
                        // Party ID
                        if (question.idQuestion === PARTY_ID_QUESTION_ID && !question.answer) {
                            return {
                                ...question,
                                answer: idPersonInsurer,
                                answerJson: idPersonInsurer,
                            }
                        }

                        // TO
                        if (question.idQuestion === 2206) {
                            return {
                                ...question,
                                answer: renderEmails(contactsTo),
                                answerJson: renderEmails(contactsTo),
                            }
                        }

                        // CC
                        if (question.idQuestion === 2205) {
                            return {
                                ...question,
                                answer: renderEmails(contactsCC),
                                answerJson: renderEmails(contactsCC),
                            }
                        }

                        // Email Body
                        if (question.idQuestion === 2200 && !question.answer) {
                            return {
                                ...question,
                                answer: emailBody,
                                answerJson: emailBody,
                            }
                        }

                        // Subject
                        if (question.idQuestion === 2201 && !question.answer) {
                            return {
                                ...question,
                                answer: subject,
                                answerJson: subject,
                            }
                        }

                        return question;
                    })

                    duplicatedEmailContent.push(updatedQuestion)
                });

                setEmailContentGroup(duplicatedEmailContent);
            } else {
                setEmailContentGroup(emailContentGroupQuestions);
            }

            setQuestionnaire(JSON.parse(JSON.stringify(questionnaire)));
        }
    };

    function handleUpdateEmailContent(currentParty, callRequest = true) {

        if (callRequest) {
            GeneralSection.events.handleSave({
                values: formik.current.values,
                emailContentGroup,
                SECTIONS,
                refQuestionnaireSent,
                submitFunction: null,
                useGetQuestionnaireAnswerRequest,
                useSaveQuestionnaireAnswerRequest,
            })
            fitinsur.setAuthToken(authContext.token);
        }
    }

    return (
        <Layout
            idOperation={props.match?.params?.idOperation}
            title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
            subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
        >
            <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
            <BrokingSummary data={summary} />
            <ContentCard
                title={statusEndorsement.title}
                icon
                info={{
                    idOperation: props.match?.params?.idOperation || null,
                    idProduct: props.location?.state?.idProduct || null
                }}
            >
                <Formik
                    innerRef={formik}
                    initialValues={{
                        internalMessage: '',
                        idPersonInsurer: currentParty.idPersonInsurer,
                        to: currentParty.contactsTo,
                        cc: currentParty.contactsCC
                    }}
                    enableReinitialize={false}
                    validateOnChange={false}
                    validateOnBlur={false}
                >
                    {
                        formikProps => (
                            <Form>
                                <Field
                                    label={'Message - (Internal)'}
                                    name={'internalMessage'}
                                    value={formikProps.values.internalMessage}
                                    onChange={(e) => formikProps?.setFieldValue('internalMessage', e)}
                                    component={TextField}
                                />
                                {
                                    allParties?.length > 0
                                    && (
                                        <EmailModal
                                            allParties={allParties}
                                            currentParty={currentParty}
                                            setCurrentParty={setCurrentParty}
                                            handleUpdateEmailContent={handleUpdateEmailContent}
                                            formikProps={formikProps}
                                            setFieldValue={formikProps?.setFieldValue}
                                        >
                                            <PartiesEmailInfo.components.RenderSection
                                                formikProps={formikProps}
                                                formikRef={formik}
                                                idOperation={props.match?.params?.idOperation}
                                                idOperationParent={props.match?.params?.idOperationParent}
                                                emailContentGroup={emailContentGroup}
                                                setEmailContentGroup={setEmailContentGroup}
                                                currentParty={currentParty}
                                                globalQuestionnaire={questionnaire}
                                                setGlobalQuestionnaire={setQuestionnaire}
                                                mc={mc}
                                            />
                                        </EmailModal>
                                    )
                                }

                                {files?.length > 0
                                    ? (
                                        <TagList3
                                            tags={files}
                                            showRecipients={true}
                                        />
                                    )
                                    : null
                                }

                                <ButtonContainer>
                                    <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                                    <RenderButtons idOperation={props.match?.params?.idOperation}>
                                        <ButtonContent>
                                            <>
                                                {!isEndorsementWithoutPaymentPack && (
                                                    <Button
                                                        style={{ marginLeft: "30px", marginTop: "5px" }}
                                                        third
                                                        id="btnRegeneratePaymentPack"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            handlePaymentConfiguration()
                                                        }}>
                                                        Payment config
                                                    </Button>
                                                )}
                                                <Button
                                                    style={{ marginLeft: "10px", marginTop: "5px" }}
                                                    primary
                                                    type="submit"
                                                    id="btnSubmitSend"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        if (!formik.current.values.internalMessage) {
                                                            mc.error("Please fill in the field: Message - (Internal)");
                                                            return;
                                                        }
                                                        GeneralSection.events.handleSave({
                                                            emailContentGroup,
                                                            refQuestionnaireSent,
                                                            SECTIONS,
                                                            submitFunction: handleSendApproval(),
                                                            useGetQuestionnaireAnswerRequest,
                                                            useSaveQuestionnaireAnswerRequest,
                                                            values: formikProps.values
                                                        })
                                                    }}
                                                >
                                                    Send for Approval
                                                </Button>
                                            </>
                                        </ButtonContent>
                                    </RenderButtons>
                                </ButtonContainer>
                            </Form>
                        )
                    }

                </Formik>
            </ContentCard>

            {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
        </Layout>
    );
}

export default PaymentPackSummaryDistribution;